export class OnlineResolutionsDraftDeleteRequest {
    resolutionId!: string
    constructor(resolutionId: string) {
      this.resolutionId = resolutionId
    }
}
